/**
 * @deprecated Use `useFeatureFlag()` from `contexts/feature-flag-context` for React components.
 * This function remains available for non-React consumers only.
 */
export const allFlags = () => (window.Fulcrum?.globals?.ldflags || {});

/**
 * @deprecated Use `useFeatureFlag(flag, defaultValue)` from `contexts/feature-flag-context` for React components.
 * This function remains available for non-React consumers only.
 */
export const variation = (flagName: string, defaultValue: any): any => {
  const flags = allFlags();

  // eslint-disable-next-line no-prototype-builtins
  if (flags.hasOwnProperty(flagName)) {
    return flags[flagName];
  }

  return defaultValue;
};
